module.exports = __webpack_public_path__ + "img/hoppin.2ed70c5e.png";